import { render, staticRenderFns } from "./PartnerTelegramCampaignModal.vue?vue&type=template&id=18132fc4"
import script from "./PartnerTelegramCampaignModal.vue?vue&type=script&lang=js"
export * from "./PartnerTelegramCampaignModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports